import * as tslib_1 from "tslib";
import { lazyCreateMailItemFiles } from 'owa-attachment-common';
import createAttachments from 'owa-mail-compose-store/lib/utils/createAttachments';
import { infoBarAddHandler, infoBarRemoveHandler, } from 'owa-mail-compose-store/lib/utils/infoBarHandlers';
export default function addItem(viewState, attachmentName, itemId, isInline) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    lazyCreateMailItemFiles.import().then(function (createMailItemFiles) {
                        var hasProcessed = false;
                        var handler = infoBarAddHandler(viewState);
                        var attachmentErrorHandler = function (messageId, infoBarMessageViewStateCreator) {
                            handler(messageId, infoBarMessageViewStateCreator);
                            if (!hasProcessed) {
                                hasProcessed = true;
                                reject({ errorType: 'UploadError', id: messageId });
                            }
                        };
                        var onFinish = function (attachmentId) {
                            if (!hasProcessed) {
                                hasProcessed = true;
                                resolve(attachmentId.Id);
                            }
                        };
                        var file = createMailItemFiles([attachmentName], [itemId]);
                        createAttachments(file, isInline, viewState, false /* shouldShare */, false /* isHiddenInline */, null /* processInlineImageBeforeUpload */, attachmentErrorHandler, infoBarRemoveHandler(viewState), onFinish);
                    });
                })];
        });
    });
}
//# sourceMappingURL=addItem.js.map